import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ReportsService } from '../../../services/reports.service';
import { PayrollReportsModel, SelectedFile, SelectedReports } from '../../../models/reports';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PickerValue } from '../../../components/generic-picker/generic-picker.component';
import { downloadFile } from '../../../tools/reports-tools';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-recurring-reports',
  templateUrl: './recurring-reports.component.html',
  styleUrls: ['./recurring-reports.component.css'],
  standalone: false
})
export class RecurringReportsComponent implements OnInit {
  @Input()
  public clientCode: string;
  public reports: PayrollReportsModel[] = [];
  public chosenMonth: PickerValue;
  public monthForm: UntypedFormGroup;
  public chosen: SelectedReports | null = null;

  public mostRecentReportDate: PickerValue;
  public oldestReportDate: PickerValue;

  @ViewChildren('accItemName') accordions: QueryList<NgbAccordionItem>;

  constructor(
    private reportService: ReportsService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.reportService.getReportRange(this.clientCode, 'Recurring').subscribe(x => {
      let minDate: Date;
      let maxDate: Date;
      if (x.MinDate == null || x.MaxDate == null) {
        maxDate = new Date();
        minDate = new Date();
      } else {
        maxDate = new Date(x.MaxDate);
        minDate = new Date(x.MinDate);
      }
      const month = maxDate.getMonth() + 1;
      this.mostRecentReportDate = { year: maxDate.getFullYear(), value: month };
      this.oldestReportDate = { year: minDate.getFullYear(), value: minDate.getMonth() + 1 };
      this.chosenMonth = { year: maxDate.getFullYear(), value: month };
      this.monthForm = this.fb.group({
        month: this.chosenMonth
      });
      this.monthForm.get('month').valueChanges.subscribe(val => this.dateChanged(val));
      this._loadReports();
    });
  }

  public closeOtherAccordions(index: number) {
    for (let i = 0; i < this.accordions.length; i++) {
      if (i == index) {
        continue;
      }

      const acc = this.accordions.get(i);
      if (!acc.collapsed) {
        acc.collapse();
      }
    }
  }

  public dateChanged(result) {
    if (this.chosenMonth != result) {
      this.chosenMonth = result;
      this._loadReports();
    }
  }
  public selectionChanged(group: PayrollReportsModel, filenames: SelectedFile[]) {
    const checkdate = new Date(group.Checkdate);
    if (
      this.chosen == null ||
      this.chosen.year !== checkdate.getFullYear() ||
      this.chosen.sequenceNumber != group.SequenceNumber
    ) {
      this.chosen = {
        year: checkdate.getFullYear(),
        sequenceNumber: group.SequenceNumber,
        filenames
      };
    } else if (filenames.length === 0) {
      this.chosen = null;
    } else {
      this.chosen.filenames = filenames;
    }
  }
  public download() {
    if (this.chosen == null || this.chosen.filenames.length === 0) {
      return;
    }
    let mimeType: string = '';
    if (this.chosen.filenames.length > 1) {
      mimeType = 'application/zip';
    } else {
      mimeType = this.chosen.filenames[0].mimeType;
    }
    const year = this.chosenMonth.year;
    const month = this.chosenMonth.value;
    const date = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);
    this.reportService
      .downloadRecurringReport(
        this.clientCode,
        this.chosen.filenames.map(x => x.file),
        mimeType,
        date,
        endDate
      )
      .subscribe(x => {
        const header = x.headers.get('X-Download-Filename');
        const name: string = JSON.parse(header).name;
        downloadFile(x.body, name);
      });
  }

  private _loadReports() {
    const year = this.chosenMonth.year;
    const month = this.chosenMonth.value;
    const date = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);
    this.reportService
      .getRecurringReports(date, endDate, this.clientCode, 'Recurring')
      .subscribe(result => {
        this.reports = [];
        for (let report of result) {
          if (
            this.reports.some(
              x =>
                x.Checkdate === report.Metadata.PayDate &&
                x.SequenceNumber === report.Metadata.SequenceNumber
            )
          ) {
            for (let group of this.reports) {
              if (
                group.Checkdate === report.Metadata.PayDate &&
                group.SequenceNumber === report.Metadata.SequenceNumber
              ) {
                group.Reports.push(report);
              }
            }
          } else {
            this.reports.push({
              Checkdate: report.Metadata.PayDate,
              SequenceNumber: report.Metadata.SequenceNumber,
              Frequency: report.Frequency,
              Reports: [report],
              PayType: report.Metadata.PayType,
              ProcessedBy: report.Metadata.ProcessedBy,
              ProcessedOn: report.Metadata.ProcessedOn,
              PeriodEndDate: report.Metadata.PeriodEndDate
            });
          }
        }
        this.reports = this.reports.sort(this._sortReports);
      });
  }
  private _sortReports(a: PayrollReportsModel, b: PayrollReportsModel) {
    if (a.Checkdate < b.Checkdate) return 1;
    if (a.Checkdate > b.Checkdate) return -1;
    return 0;
  }
}
